import React from 'react';
import { FormGroup, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setProductBugPop} from '../../store/api/GetAllProduct';
import { searchProductBug } from '../../store/api/TaskDetailsApi';
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBug, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalSelectProductBug = () => {
    const selectBugModalStatus = useSelector(state => state.ProductReducer.selectBugModalStatus);
    const productBugList = useSelector(state => state.ProductReducer.productBugList?.Data);
    const dispatch = useDispatch();
    const search = () => {
        let itemDesc = document.getElementsByName("ItemDescForSeach")[0].value;
        let data = {};
        data.ProductID = selectBugModalStatus.productID;
        data.ProductTypeID = selectBugModalStatus.productTypeID;
        data.Bug = itemDesc;
        data.JustThisProduct = document.getElementById("JustThisProduct").value;
        dispatch(searchProductBug(data));
    }
    const select = (item) => {
        if (selectBugModalStatus.setData) {
            selectBugModalStatus.setData(item);
        }
        dispatch(setProductBugPop({ status: 'hide' }));
    }
    return (
        <Modal show={selectBugModalStatus.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
              <span>  <FontAwesomeIcon icon={faBug} size='lg'/>&nbsp; انتخاب ایراد از لیست</span><FontAwesomeIcon icon={faTimes} size='lg' onClick={() => dispatch(setProductBugPop({ status: 'hide' }))}/></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className="row">
                    <FormGroup>
                        <input type='checkbox' className='form-check-input' id='JustThisProduct'/> &nbsp;تنها ایرادهای این محصول نمایش داده شود
                    </FormGroup>
                    <div className="form-group">
                        <input type="text" name="ItemDescForSeach" placeholder="شرح ایراد" className="form-control" />
                    </div>
                </div>
                <button type="button" className="btn btn-primary w-100 mt-2" onClick={search}>جستجو</button>
                <br />
                <br />
                <Table className='fixedTable'>
                    <thead>
                        <tr>
                            <th style={{width:"20%"}}>کد ایراد</th>
                            <th style={{width:"80%"}}>شرح ایراد</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productBugList === "PENDING" &&
                            <tr><td colSpan={2} style={{ textAlign: "center",width:"100%" }}> <Loader type="BallTriangle" color="#bb1370" height={30} width={30} /></td></tr>}
                        {productBugList && Array.isArray(productBugList) &&
                            productBugList.map((item, i) => {
                                return <tr className="resultTableRow" key={i} onClick={() => select(item)}>
                                    <td style={{width:"20%"}}>{item.Code}</td>
                                    <td style={{width:"80%"}}>{item.Bug}</td>
                                </tr>
                            })}
                    </tbody>

                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectProductBug;